import apiStockist from '@/api/ecommerce/stockist';

const defaultState = () => ({
	listStockist: [],
	paginationStockist: '',
	listStockistStock: [],
	paginationStockistStock: '',
	listStockistStockLog: [],
	paginationStockistStockLog: '',
});

const state = defaultState();

const getters = {

};

const mutations = {
	setStockist(state, data) {
		state.listStockist = data.data
		state.paginationStockist = data.pagination;
	},
	setStockistStock(state, data) {
		state.listStockistStock = data.data
		state.paginationStockistStock = data.pagination;
	},
	setStockistStockLog(state, data) {
		state.listStockistStockLog = data.data
		state.paginationStockistStockLog = data.pagination;
	},
	clearDataStockist(state) {
		Object.assign(state, defaultState())
	}
};

const actions = {
	getStockist({ commit, dispatch }, params) {
		apiStockist.getDataStockist(params).then(({ data: { data } }) => {
			commit('setStockist', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setStockist', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
	},
	async exportStockist({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiStockist.exportStockist(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Produk'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	getStockistBank({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiStockist.getDataStockistBank(params).then(({ data: { data } }) => {
				resolve(data.results)
			}).catch((err) => {
				const data = err.response.data
				dispatch("errorHandler", data, { root: true })
				reject({})
			});
		})
	},
	saveStockistBank({ dispatch }, params) {
		return new Promise((resolve, reject) => {
			apiStockist.saveStockistBank(params).then(res => {
				const data = res.data;
				dispatch('success', data.message, { root: true })
				resolve(true)
			}).catch( err => {
				const data = err.response.data
				dispatch("errorHandler", data, { root: true })
				reject(false)
			});
		})
	},
	getStockistStock({ commit, dispatch }, params) {
		apiStockist.getStockistStock(params).then(({ data: { data } }) => {
			commit('setStockistStock', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setStockistStock', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
	},
	async exportStockistStock({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiStockist.exportStockistStock(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Produk'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
	getStockistStockLog({ commit, dispatch }, params) {
		apiStockist.getStockistStockLog(params).then(({ data: { data } }) => {
			commit('setStockistStockLog', { data: data.results, pagination: data.pagination });
		}).catch((err) => {
			commit('setStockistStockLog', { data: [], pagination: {} });
			const data = err.response.data
			dispatch("errorHandler", data, { root: true })
		});
	},
	async exportStockistStockLog({ commit, dispatch }, params){
		await dispatch('isAttempting', null, { root: true })
		await apiStockist.exportStockistStockLog(params).then(({ data: { data } }) => {
			dispatch('success', data.results.message, { root: true })
			window.location = `${process.env.VUE_APP_API_HOST}/${data.results.url}`;
		}).catch(() => {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: 'Gagal memproses export data Produk'
			}, { root: true });
		});
		await dispatch('attempted', null, { root: true })
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};